import { React, useEffect, useState } from "react";
import FormAccordion from "../../../components/Form/FormAccordion";
import DialogBox from "../../../components/ReusableComponents/DialogBox";
import {Input} from "./Input";
import { ProductFormWrapper, ButtonGroup, Button } from "./ProductForm.styled";
import { ordersInputData } from "./InputData";
import thrashIcon from "../../../assets/icons/trash.svg";
import Parse from "../../../api/ApiConfig";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import { getFormattedDate } from "../../../utils/DateUtils";
import { getFormattedAmount } from "../../../utils/AmountUtils";
import { TextAreaField } from "../../lease/partials/FormComponents";


/* eslint-disable react/prop-types */
function SingleOrderForm({ setProductName, setProductPrice, setImagesUrl }) {
	const [ordersForm, SetOrdersForm] = useState({
		date: "",
		transactionId: "",
		asset: "",
		value: "",
		paymentType: "",
		paymentMethod: "",
		amount: "",
		saleStatus: "",
		outstanding: "",
		description: "",
		keyFeatures: "",
		specifications: "",
	});
	let { productId } = useParams();
	const [openDialog, setOpenDialog] = useState(false);
	const [text, setText] = useState("");

	useEffect(() => {
		const fetchOrderDetails = async () => {
			const Orders = Parse.Object.extend("Orders");
			const query = new Parse.Query(Orders);
			query.equalTo("objectId", productId);
			const orders = await query.find();
			// console.log(orders)
			SetOrdersForm({
				date: getFormattedDate(orders[0].createdAt),
				transactionId: orders[0].attributes.transactionId.toUpperCase(),
				asset: orders[0].attributes.asset.toUpperCase(),
				value: getFormattedAmount.format(orders[0].attributes.value),
				paymentType: orders[0].attributes.paymentType.toUpperCase(),
				paymentMethod: orders[0].attributes.paymentMethod.toUpperCase(),
				amount: getFormattedAmount.format(orders[0].attributes.amount),
				saleStatus: orders[0].attributes.saleStatus.toUpperCase(),
				outstanding: getFormattedAmount.format(
					orders[0].attributes.outstanding
				),
				description: "ELITEBOOK 840 G5",
				keyFeatures:
					"Operating system:  WINDOWS 10 PRO UPGRADEABLE TO WINDOWS 11 PRO",
				specifications:
					"EliteBook 840 G5; Intel Core I5- 16GB RAM/1TB SSD/Backlit Keyboard/FP; Reader Windows 10 Pro + BAG;",

				// image: orders[0].attributes.image,
			});

			setProductName(orders[0].attributes.asset.toUpperCase());
			setProductPrice(orders[0].attributes.value);
			setImagesUrl({
				firstImage: "",
				secondImage: "",
				thirdImage: "",
			});
		};

		fetchOrderDetails();
	}, []);

	const deleteOrder = () => {
		console.log("Be fr");

		const Orders = Parse.Object.extend("Orders");
		let query = new Parse.Query(Orders);
		query
			.get(productId)
			.then((product) => {
				return product.destroy();
			})
			.then((deletedObject) => {
				// setType("")
				toast.success(
					"Product deleted successfully, Check products table to see the updated list",
					deletedObject
				);
			})
			.catch((error) => {
				// setType("")
				toast.error(error, "unable to delete product, please try again");
			});
	};

	//close dialog
	const handleClose = () => {
		setOpenDialog(false);
	};

	//open modal
	const openModal = () => {
		setText("Are you sure you want to Delete this Product?");
		setOpenDialog(true);
	};

	//call delete function after clicking yes
	const handleYes = () => {
		deleteOrder();
		setOpenDialog(false);
	};
	return (
		<FormAccordion title='Product Information' open={true}>
			<DialogBox
				openDialog={openDialog}
				handleClose={handleClose}
				text={text}
				onSubmit={handleYes}
			/>
			<ProductFormWrapper>
				{ordersInputData.map((item) => {
					return (
						<Input
							status='true'
							key={item.id}
							value={ordersForm[item.name] || ""}
							title={item.title}
							type={item.type}
							name={item.name}
							backGroundColor= {ordersForm[item.name] || ""}
						/>
					);
				})}
			</ProductFormWrapper>
			<FormAccordion title='Product description' open={true}>
				<div className='form-group'>
					<TextAreaField
						name='description'
						// handleChange={handleChange}
						value={ordersForm.description?.replace(/;/g, "<br/>")}
						
					/>
				</div>
			</FormAccordion>

			<FormAccordion title='Key features'>
				<div className='form-group'>
					<TextAreaField
						name='keyFeatures'
						// handleChange={handleChange}
						value={ordersForm.keyFeatures?.replace(/;/g, "<br/>")}
					/>
				</div>
			</FormAccordion>

			<FormAccordion title='Product specifications'>
				<div className='form-group'>
					<TextAreaField
						name='specifications'
						// handleChange={handleChange}
						value={ordersForm.specifications?.replace(/;/g, "<br/>")}
					/>
				</div>
			</FormAccordion>

			<ButtonGroup>
				<Button
					type='button'
					backgroundcolor='#FF7878'
					color='#ffffff'
					onClick={openModal}
				>
					<img src={thrashIcon} />
					<p>Delete</p>
				</Button>
			</ButtonGroup>
		</FormAccordion>
	);
}

export default SingleOrderForm;
